import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../Components/Core/Container';
import Link from '../../Components/Core/Link';

export const StyledContainer = styled(Container)`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-top: 100px;
  }
`;

export const DownloadLink = styled(Link)`
  position: relative;
  display: flex;
  justify-content: flex-end;

  &::after,
  &::before {
    width: 100%;
    height: 100%;
    max-height: 24px;
    min-height: 24px;
    max-width: 25px;
    min-width: 25px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    display: inline-block;
  }
`;

export const StyledLegalPage = styled.div`
  div {
    font-family: ${themeGet('fonts.noir')};
  }

  h1 {
    font-size: 1rem;
    display: flex;
    justify-content: center;
  }

  h2 {
    font-size: 1rem;
  }

  strong {
    font-size: 0.875rem;
  }

  a {
    text-decoration: none;
  }

  p {
    font-size: 0.75rem;
    margin: 0 0 0.5rem;
  }

  thead {
    display: none;
  }

  table td {
    width: auto;
  }

  table {
    width: 100%;
    border-spacing: 0px;
    font-size: 0.75rem;
    ul {
      margin-block: inherit;
    }
  }
`;
